import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { ModulesRoute } from '../../constants';

function setupProfile(): void {
  applicationModuleRegistry.register({
    entry: 'profile',
    id: 'profile',
    name: 'modules.profile',
    route: ModulesRoute.PROFILE,
    closeable: true,
  });
}

export {
  setupProfile,
};
